import React from 'react';
import { Location, NavigateFunction, Params, useLocation, useNavigate, useParams } from 'react-router-dom';
import hoistStatics from 'hoist-non-react-statics';

export interface RouteComponentProps<T extends string = string> {
    location: Location;
    params: Params<T>;
    navigate: NavigateFunction;
}

function withRouter<SelfProps>(
    Component: React.ComponentType<SelfProps & RouteComponentProps>
): React.FC<Omit<SelfProps, keyof RouteComponentProps>> {
    const displayName = `withRouter(${Component.displayName || Component.name})`;

    const WithRouter: React.FC<Omit<SelfProps, keyof RouteComponentProps>> = props => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
        const { ...restProps } = props;

        return <Component {...(restProps as any)} location={location} params={params} navigate={navigate} />;
    };

    WithRouter.displayName = displayName;

    return hoistStatics(WithRouter, Component);
}

export default withRouter;
